import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicHooksComponent } from 'ngx-dynamic-hooks';
import { CountdownComponent } from 'countdown';
import { LinkComponent } from 'link';
import { OfferBoxButtonComponent, OfferBoxComponent, OfferStickerComponent } from 'offer-box';

@Component({
  selector: 'lib-offer-box-light',
  templateUrl: './offer-box-light.component.html',
  styleUrls: ['./offer-box-light.component.scss'],
  standalone: true,
  imports: [
    LinkComponent,
    NgTemplateOutlet,
    NgClass,
    OfferStickerComponent,
    DynamicHooksComponent,
    OfferBoxButtonComponent,
    CountdownComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferBoxLightComponent extends OfferBoxComponent {
  @Input() styleSide: 'left' | 'right' = 'left';
}
